/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AchievementsEducationLevel {
  ASSOCIATES_DEGREE = "ASSOCIATES_DEGREE",
  BACHELORS_DEGREE = "BACHELORS_DEGREE",
  EIGHTEEN_PLUS_CREDITS = "EIGHTEEN_PLUS_CREDITS",
  MASTERS_DEGREE = "MASTERS_DEGREE",
  SIX_PLUS_CREDITS = "SIX_PLUS_CREDITS",
  TWELVE_PLUS_CREDITS = "TWELVE_PLUS_CREDITS",
}

export enum AchievementsExperience {
  FIFTEEN_PLUS_YEARS = "FIFTEEN_PLUS_YEARS",
  FIVE_PLUS_YEARS = "FIVE_PLUS_YEARS",
  FOUR_PLUS_YEARS = "FOUR_PLUS_YEARS",
  ONE_PLUS_YEAR = "ONE_PLUS_YEAR",
  TEN_PLUS_YEARS = "TEN_PLUS_YEARS",
  THREE_PLUS_YEARS = "THREE_PLUS_YEARS",
  TWENTY_PLUS_YEARS = "TWENTY_PLUS_YEARS",
  TWO_PLUS_YEARS = "TWO_PLUS_YEARS",
}

export enum BillingCouponDuration {
  FOREVER = "FOREVER",
  ONCE = "ONCE",
  REPEATING = "REPEATING",
}

export enum EnrollmentStatus {
  ENROLLED = "ENROLLED",
  PENDING = "PENDING",
  UNENROLLED = "UNENROLLED",
  VOID = "VOID",
}

export enum GatheringType {
  ARTS_AND_CRAFTS = "ARTS_AND_CRAFTS",
  GROUP_TOUR = "GROUP_TOUR",
  MUSIC_CIRCLE = "MUSIC_CIRCLE",
  OPEN_HOUSE = "OPEN_HOUSE",
  OTHER = "OTHER",
  PETTING_ZOO = "PETTING_ZOO",
  PLAY_DATE = "PLAY_DATE",
  READING_CIRCLE = "READING_CIRCLE",
}

export enum Gender {
  BOY = "BOY",
  GIRL = "GIRL",
  OTHER = "OTHER",
}

export enum IntendedRole {
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  OWNER = "OWNER",
}

export enum InvitationType {
  APP = "APP",
  ENROLLMENT = "ENROLLMENT",
  PAYMENT = "PAYMENT",
}

export enum OfflineInvoicePayerType {
  government = "government",
  local_subsidy_agent = "local_subsidy_agent",
  other = "other",
  student = "student",
}

export enum OfflineInvoicePaymentMethodType {
  cash = "cash",
  check = "check",
  money_order = "money_order",
  offline_credit_card = "offline_credit_card",
  other = "other",
  payment_app = "payment_app",
}

export enum OfflineInvoiceType {
  cares_act = "cares_act",
  deposit = "deposit",
  diaper_fee = "diaper_fee",
  drop_in_fee = "drop_in_fee",
  enrollment_fee = "enrollment_fee",
  extra_activity_fee = "extra_activity_fee",
  field_trip_fee = "field_trip_fee",
  government_funding = "government_funding",
  granted_funding = "granted_funding",
  hot_lunch_fee = "hot_lunch_fee",
  late_fee = "late_fee",
  materials_fee = "materials_fee",
  other = "other",
  ppp_loan = "ppp_loan",
  subsidy = "subsidy",
  tuition_payment = "tuition_payment",
}

export enum PaymentMethodPendingVerificationType {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

export enum SchoolListingType {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

export enum StaffStatus {
  ADMIN = "ADMIN",
  DIRECTOR = "DIRECTOR",
  PENDING = "PENDING",
  TEACHER = "TEACHER",
  UNKNOWN = "UNKNOWN",
}

export enum TuitionInterval {
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}

export interface Account {
  id: string;
  mask?: string | null;
  name?: string | null;
  subtype?: string | null;
  type?: string | null;
  verificationStatus?: string | null;
}

export interface AddressInput {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  postalCode: string;
  state?: string | null;
}

export interface AvailabilityGroupParams {
  ageMonthsMax: number;
  ageMonthsMin: number;
  openSpotsCount: number;
}

export interface ChildParams {
  allergies?: string | null;
  animalAllergiesOrFear?: string | null;
  avatarUrl?: string | null;
  birthday?: any | null;
  compostableDiapers?: string | null;
  desiredEnrollmentDate?: any | null;
  dietaryRestrictions?: string | null;
  firstName?: string | null;
  gender?: Gender | null;
  habitsAndBehaviors?: string | null;
  id?: number | null;
  lastName?: string | null;
  limitedEnglishExposure?: string | null;
  medicalConditions?: string | null;
  medications?: string | null;
  metalOrGlassOnly?: string | null;
  other?: string | null;
  previousChildcareExperience?: PreviousChildcareExperienceParams | null;
  specialNeeds?: string | null;
  unvaccinated?: string | null;
}

export interface CreateDirectorUserParams {
  birthdate?: string | null;
  directorTosAgreed: boolean;
  email: string;
  family: FamilyParams;
  firstName: string;
  isLicensed?: boolean | null;
  lastName: string;
  networkId?: string | null;
  password?: string | null;
  phone?: string | null;
  postalCode?: string | null;
  signUpSource: string;
}

export interface CreateEnrollmentApplicationParams {
  childId: number;
  classId: number;
  note?: string | null;
  periodAttendees: EnrollmentApplicationPeriodAttendeeParams[];
  programDiscoveryAnswer?: string | null;
  startDate: any;
}

export interface CreateGatheringRegistrationChildParams {
  birthday: any;
  desiredEnrollmentDate: any;
}

export interface CreateInvitationParams {
  body: string;
  studentId: number;
  type: InvitationType;
}

export interface CreateOfflineInvoiceParams {
  amount: number;
  childId?: number | null;
  invoicedOn: string;
  note?: string | null;
  payer: OfflineInvoicePayerType;
  payerOtherDetail?: string | null;
  paymentMethod: OfflineInvoicePaymentMethodType;
  type: OfflineInvoiceType;
  typeOtherDetail?: string | null;
}

export interface CreateParentUserParams {
  email: string;
  family: FamilyParams;
  firstName: string;
  lastName?: string | null;
  parentTosAgreed: boolean;
  password?: string | null;
  phone?: string | null;
  signUpSource: string;
}

export interface CreateStudentParams {
  childId?: number | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  firstName: string;
  lastName?: string | null;
}

export interface DesiredWeeklyScheduleParams {
  dropoffAt: any;
  friday: boolean;
  monday: boolean;
  pickupAt: any;
  thursday: boolean;
  tuesday: boolean;
  wednesday: boolean;
}

export interface EnrollmentApplicationPeriodAttendeeParams {
  beginsAt: any;
  endsAt: any;
  weekday: number;
}

export interface FamilyParams {
  children?: ChildParams[] | null;
}

export interface FeatureRequestParams {
  client: string;
  device: string;
  request: string;
  version?: string | null;
}

export interface GatheringRegistrationParams {
  quantity: number;
}

export interface InstantEnrollParams {
  childId: number;
  classId: number;
  schedules: InstantEnrollScheduleParams[];
}

export interface InstantEnrollScheduleParams {
  beginsOn: any;
  offlineReason?: string | null;
  periodAttendees: PeriodParams[];
  tuitionInterval: TuitionInterval;
}

export interface Institution {
  institutionId?: string | null;
  name?: string | null;
}

export interface InvitationScheduleParams {
  scheduleId: number;
  tuitionInterval: string;
}

export interface LeadContactChildParams {
  birthday: any;
  desiredEnrollmentDate: any;
}

export interface LookupChildParams {
  contactEmail?: string | null;
  firstName: string;
  lastName?: string | null;
}

export interface MapsBoundsInput {
  northEast: MapsCoordsInput;
  southWest: MapsCoordsInput;
}

export interface MapsCoordsInput {
  latitude: number;
  longitude: number;
}

export interface Metadata {
  account: Account;
  accountId?: string | null;
  accounts?: (Account | null)[] | null;
  institution?: Institution | null;
  linkSessionId?: string | null;
  publicToken?: string | null;
}

export interface PaymentMethodPendingParams {
  accountLast4?: string | null;
  accountName: string;
  plaidAccountId: string;
  verificationType: PaymentMethodPendingVerificationType;
}

export interface PeriodParams {
  beginsAt: any;
  endsAt: any;
  weekday: number;
}

export interface PreviousChildcareExperienceParams {
  childcare: boolean;
  childcareCenter: boolean;
  familyMember: boolean;
  nanny: boolean;
  sharecare: boolean;
  stayAtHomeParent: boolean;
}

export interface ProfileFeatureParams {
  name: string;
  value: string;
}

export interface ProfileMediaParams {
  caption?: string | null;
  index: number;
  mediaId: string;
}

export interface ProfileParams {
  additionalInfo?: string | null;
  ageMonthsMax?: number | null;
  ageMonthsMin?: number | null;
  content?: any | null;
  daysOfWeek?: boolean[] | null;
  daysPerWeek?: number[] | null;
  features?: ProfileFeatureParams[] | null;
  hourlyRate?: number | null;
  hoursEnd?: string | null;
  hoursRegularEnd?: string | null;
  hoursRegularStart?: string | null;
  hoursStart?: string | null;
  language?: string | null;
  languageOther?: string | null;
  mealsBreakfastProvided?: boolean | null;
  mealsDinnerProvided?: boolean | null;
  mealsLunchProvided?: boolean | null;
  numberOfCaregivers?: number | null;
  philosophy?: string | null;
  philosophySecondary?: string | null;
  pottyTrainingRequired?: boolean | null;
  profileMedia?: (ProfileMediaParams | null)[] | null;
  programOfferings?: ProgramOfferingParams[] | null;
  providerChildRatioConsequent?: number | null;
  snacksProvidedCount?: number | null;
  spokenLanguages?: string[] | null;
  subsidies?: SubsidyParams[] | null;
  subsidizedCareAccepted?: boolean | null;
}

export interface ProgramOfferingParams {
  id: number;
  networkId?: string | null;
}

export interface SchoolBasicsParams {
  profile?: ProfileParams | null;
  programType?: string | null;
}

export interface SchoolListingsFiltersInput {
  acceptsSubsidy?: boolean | null;
  acceptsWeeklyBilling?: boolean | null;
  budgetMax?: number | null;
  budgetMin?: number | null;
  daysPerWeek?: number[] | null;
  dropOffEndsAt?: string | null;
  dropOffStartsAt?: string | null;
  enrollingAgeMonthsMax?: number | null;
  enrollingAgeMonthsMin?: number | null;
  hasAvailability?: boolean | null;
  hasUpcomingGatherings?: boolean | null;
  isTouring?: boolean | null;
  pickUpEndsAt?: string | null;
  pickUpStartsAt?: string | null;
  selectedNetworkRatings?: number[] | null;
  selectedProgramOfferings?: number[] | null;
  selectedProgramTypes?: string[] | null;
  selectedSpokenLanguages?: string[] | null;
  selectedSubsidies?: number[] | null;
  selectedWhitelabelRatings?: string[] | null;
}

export interface SchoolListingsLocationByBoundsInput {
  bounds?: MapsBoundsInput | null;
  query?: string | null;
}

export interface SchoolListingsLocationByCenterInput {
  coords?: MapsCoordsInput | null;
  ip?: boolean | null;
  query?: string | null;
  radius?: number | null;
}

export interface SchoolListingsLocationInput {
  byBounds?: SchoolListingsLocationByBoundsInput | null;
  byCenter?: SchoolListingsLocationByCenterInput | null;
}

export interface SchoolListingsRankingFactorWeightsInput {
  distance?: number | null;
  freshness?: number | null;
  touring?: number | null;
  type?: number | null;
  utilization?: number | null;
}

export interface SchoolTuitionBillingPolicyParams {
  monthlyBillingOffsetDays: number;
  monthlyBillingOffsetMonths: number;
  weeklyBillingAccepted: boolean;
  weeklyBillingDayOfWeek: number;
  weeklyBillingOffsetWeeks: number;
}

export interface SchoolTuitionProgramParams {
  ageMonthsMax: number;
  ageMonthsMin: number;
  hoursEnd?: any | null;
  hoursStart?: any | null;
  isRegularEnd?: boolean | null;
  isRegularStart?: boolean | null;
  name: string;
  priceOptions: SchoolTuitionProgramPriceOptionParams[];
}

export interface SchoolTuitionProgramPriceOptionParams {
  daysPerWeek: number;
  hidden: boolean;
  monthlyRate: number;
  weeklyRate?: number | null;
}

export interface SubsidyParams {
  id: number;
  name: string;
  networkId: string;
}

export interface SwitchTuitionAmountParams {
  scheduleId: number;
  tuitionAmount: number;
}

export interface SwitchTuitionTarget {
  amount: number;
  beginsOn: any;
  interval: string;
}

export interface TourParams {
  beginsAt: string;
  childIds?: number[] | null;
  endsAt: string;
}

export interface TourRequestAvailabilityParams {
  beginsAt: string;
}

export interface TourRequestParams {
  availabilities?: TourRequestAvailabilityParams[] | null;
  childIds?: number[] | null;
  cookieFromProviderReferral?: string | null;
  referringUrl?: string | null;
  schoolId: number;
}

export interface TuitionBillingSettingParams {
  monthlyBillingOffsetDays: number;
  monthlyBillingOffsetMonths: number;
  weeklyBillingDayOfWeek: number;
  weeklyBillingOffsetWeeks: number;
}

export interface UnenrollParams {
  endsOn: any;
  unenrolledReason: string;
}

export interface UpdateOfflineInvoiceParams {
  amount?: number | null;
  childId?: number | null;
  invoicedOn?: string | null;
  note?: string | null;
  payer?: OfflineInvoicePayerType | null;
  payerOtherDetail?: string | null;
  paymentMethod?: OfflineInvoicePaymentMethodType | null;
  type?: OfflineInvoiceType | null;
  typeOtherDetail?: string | null;
}

export interface UpdateScheduleSubsidyDetailsParams {
  offlineReason: string;
  subsidyAmount?: number | null;
  subsidyFamilyFee?: number | null;
  subsidyProgramFee?: number | null;
}

export interface UpdateScheduleTuitionDetailsParams {
  beginsOn: any;
  tuitionAmount?: number | null;
  tuitionAmountWeekly?: number | null;
  tuitionInterval?: string | null;
}

export interface UpdateStudentParams {
  contactEmail?: string | null;
  contactPhone?: string | null;
}

export interface UpdateUserParams {
  address?: AddressInput | null;
  avatarUrl?: string | null;
  directorQspAgreed?: boolean | null;
  email?: string | null;
  firstName?: string | null;
  internalRole?: string | null;
  lastName?: string | null;
  name?: string | null;
  password?: string | null;
  phone?: string | null;
  preferredLanguage?: string | null;
  referredBy?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
